import { PREFERENCE_IDENTIFIERS } from "../../../util/constants";
import { graphqlApi } from "../../graphql/api";
import { selectBuckeyeLinkLinks } from "../../graphql/slices/buckeye-link";
import { initializePreferences, setQuickLinkPreferences } from "../../graphql/slices/preferences";
import { getPreferences, updatePreferences } from "../enums";

const CONSTANTS = {
  get: getPreferences,
  update: updatePreferences
};

const get = `
  ${CONSTANTS.get} {
    key
    value
    search {
      type
      links {
        link
        title
      }
    }
    quickLinks {
      link
      title
    }
  }
`;

const update = `
  ${CONSTANTS.update} (key: $key, value: $value, type: $type) {
    key
    value
    search {
      type
      links {
        link
        title
      }
    }
    quickLinks {
      link
      title
    }
  }
`;

export const findBuckeyeLinkMatch = (buckeyeLinkData = [], preference = {}) => {
  const hardMatch = buckeyeLinkData.find(s3Data => s3Data.link === preference.link)
  const softMatch = buckeyeLinkData.find(s3Data => s3Data.title === preference.title)
  if(hardMatch) {
    return {
      ...preference,
      ...hardMatch
    }
  } else if (softMatch) {
    return {
      ...preference,
      ...softMatch
    }
  }
  return preference
}

export const updatePreferencesForQuickLinks = async ({
  data = [],
  dispatch,
  getState
}) => {
  const state = getState()
  let quickLinksOverride = data
  if(quickLinksOverride?.length >= 3) {
    let buckeyeLinkData = selectBuckeyeLinkLinks(state)
    if(!buckeyeLinkData?.length) {
      await dispatch(graphqlApi.endpoints.getBuckeyeLinkData.initiate())  
      buckeyeLinkData = selectBuckeyeLinkLinks(getState())
    }
    if(buckeyeLinkData?.length) {
      //Adding this logic in to help ease any issues that may arise for data changes. Link would be more reliable than title, hence the two types of match options. 
      quickLinksOverride = quickLinksOverride.map(preference => findBuckeyeLinkMatch(buckeyeLinkData, preference))
  
    }  
    dispatch(setQuickLinkPreferences(quickLinksOverride))
  } else {
    dispatch(setQuickLinkPreferences([]))
  }
}

const transformResponse = async (response = {}, { dispatch, getState }) => {
  const storedPreferences = response?.data?.[getPreferences] ?? []
  await updatePreferencesForQuickLinks({
    dispatch,
    getState,
    data: storedPreferences.find(({ key }) => key.startsWith(PREFERENCE_IDENTIFIERS.QUICKLINKS))?.quickLinks ?? []
  })


  dispatch(initializePreferences(storedPreferences))
  return response
};

const source = {
  CONSTANTS,
  QUERIES: {
    get,
    update
  },
  transformResponse
};

export default source;